import { Link } from "react-router-dom"

import type { ContractFixStep } from "./contract-kind-bundle"

const FIX_LINK_CLASS = `w-fit text-[length:var(--step--2)] font-semibold text-bp-accent underline underline-offset-2 hover:text-bp-text`

/** The link under a blocker to the Setup step (or status drawer) that clears it. */
export const ContractFixLink = ({
  to,
  label,
}: {
  to: string
  label: string
}): JSX.Element => (
  <Link to={to} className={FIX_LINK_CLASS}>
    {label}
  </Link>
)

export const ContractFixStepLink = ({
  step,
}: {
  step: ContractFixStep
}): JSX.Element => <ContractFixLink to={step.path} label={step.label} />

/**
 * A command run in place under a blocker (Refresh pricing, Recalculate
 * savings, Retry production), with its failure beside the button.
 */
export const ContractFixCommand = ({
  label,
  busyLabel,
  busy,
  errorMessage,
  onRun,
}: {
  label: string
  busyLabel: string
  busy: boolean
  /** Shown while the last run failed; null hides it. */
  errorMessage: string | null
  onRun: () => void
}): JSX.Element => (
  <div className="flex flex-wrap items-center gap-3">
    <button
      type="button"
      disabled={busy}
      onClick={onRun}
      className="rounded-md bg-bp-accent px-3 py-1.5 text-[length:var(--step--2)] font-semibold text-bp-on-accent hover:bg-bp-accent-hover disabled:cursor-not-allowed disabled:opacity-50"
    >
      {busy ? busyLabel : label}
    </button>
    {errorMessage != null ? (
      <p role="alert" className="text-[length:var(--step--2)] text-bp-danger">
        {errorMessage}
      </p>
    ) : null}
  </div>
)
